import type {PropsWithChildren} from 'react';
import clsx from 'clsx';

type Props = PropsWithChildren & {
	rows?: 2 | 3;
};

export const GridList = ({children, rows = 3}: Props) => {
	return (
		<ul
			className={clsx(
				'grid',
				'md:grid-cols-2',
				rows === 2 ? '' : 'lg:grid-cols-3',
				'gap-x-13',
				'gap-y-12',
			)}
		>
			{children}
		</ul>
	);
};
